/** Home hub card palette — hub-specific colors (gradient lives in theme/appGradientPalette). */

export const homePalette = {
  hubTitle: '#3C3C3E',
  hubCardBorder: '#FFFFFF',
  hubStepBadgeBorder: '#E5E7EB',
  hubCtaHover: '#F9FAFB',
  hubCardBackgroundOpacity: 0.2,
  hubCardHoverBackgroundOpacity: 0.6,
} as const;
